import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { trackCTAClick } from "@/lib/analytics";

const tiers = [
    {
        name: "Launch",
        price: "£249",
        blurb: "For businesses getting started with measurable marketing.",
    },
    {
        name: "Growth",
        price: "£499",
        blurb: "For growing businesses ready to scale qualified enquiries.",
        featured: true,
    },
    {
        name: "Growth Pro",
        price: "£699",
        blurb: "For businesses maximising return on marketing spend.",
    },
];

export const Pricing = () => (
    <section
        id="pricing"
        data-testid="pricing-section"
        className="scroll-mt-16 bg-white py-24 lg:py-32"
    >
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <Reveal>
                <p className="text-sm font-semibold uppercase tracking-wider text-[#2563EB]">
                    Pricing
                </p>
                <h2 className="mt-3 max-w-2xl text-3xl font-bold tracking-tight text-[#0B1F44] lg:text-4xl">
                    Simple plans, built around your growth stage.
                </h2>
            </Reveal>
            <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3">
                {tiers.map((t, i) => (
                    <Reveal key={t.name} delay={i * 0.08}>
                        <div
                            data-testid={`pricing-tier-${t.name.toLowerCase().replace(" ", "-")}`}
                            className={`fp-card-shadow flex h-full flex-col rounded-2xl border p-8 ${
                                t.featured
                                    ? "border-[#2563EB] bg-white ring-1 ring-[#2563EB]/20"
                                    : "border-gray-100 bg-[#F8FAFC]"
                            }`}
                        >
                            {t.featured && (
                                <span className="mb-4 inline-flex w-fit rounded-full bg-[#2563EB]/10 px-3 py-1 text-xs font-semibold text-[#2563EB]">
                                    Most popular
                                </span>
                            )}
                            <h3 className="text-lg font-semibold text-[#0B1F44]">
                                {t.name}
                            </h3>
                            <p className="mt-4">
                                <span className="text-sm text-[#6B7280]">
                                    From{" "}
                                </span>
                                <span className="text-4xl font-bold tracking-tight text-[#0B1F44]">
                                    {t.price}
                                </span>
                                <span className="text-sm text-[#6B7280]">
                                    /month
                                </span>
                            </p>
                            <p className="mt-4 flex-1 text-sm leading-relaxed text-[#4B5563]">
                                {t.blurb}
                            </p>
                            <a
                                href="#growth-review"
                                data-testid={`pricing-cta-${t.name.toLowerCase().replace(" ", "-")}`}
                                onClick={() => trackCTAClick(`pricing_${t.name.toLowerCase().replace(" ", "_")}`)}
                                className={`mt-8 inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold transition-colors ${
                                    t.featured
                                        ? "bg-[#2563EB] text-white hover:bg-blue-700"
                                        : "border border-[#0B1F44] bg-white text-[#0B1F44] hover:bg-gray-50"
                                }`}
                            >
                                Book a Growth Review
                                <ArrowRight className="h-4 w-4" />
                            </a>
                        </div>
                    </Reveal>
                ))}
            </div>
            <Reveal delay={0.2}>
                <p className="mt-8 text-center text-xs text-[#6B7280]">
                    Setup fees and advertising spend are separate. Pricing
                    depends on configuration and integrations.
                </p>
            </Reveal>
        </div>
    </section>
);
